// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.wallet-content {
  background-color: var(--bg-secondary, #fff);
  border-radius: 12px;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  color: var(--text-primary, #14171a);
}

.wallet-header-fixed {
  position: sticky;
  top: 0;
  background-color: var(--bg-secondary, #fff);
  border-bottom: 2px solid var(--border-color, #e1e8ed);
  padding: 20px 30px;
  border-radius: 12px 12px 0 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wallet-header-title {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
  flex-wrap: wrap;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.include-delegated-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--text-primary, #14171a);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.include-delegated-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--accent-primary, #1da1f2);
}

.wallet-header-fixed h2 {
  margin: 0;
  font-size: 24px;
  color: var(--text-primary, #14171a);
}

.close-button {
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  color: var(--text-secondary, #536471);
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-button:hover {
  background-color: var(--hover-background, rgba(29, 161, 242, 0.1));
  color: var(--text-primary, #14171a);
}

.fetch-totals-button {
  background-color: var(--accent-primary, #1da1f2);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.fetch-totals-button:hover:not(:disabled) {
  background-color: var(--accent-hover, #1a8cd8);
  transform: translateY(-1px);
}

.fetch-totals-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wallet-body {
  overflow-y: auto;
  padding: 20px 30px;
  flex: 1 1;
}

.totals-section,
.detailed-section,
.savings-section,
.hivepower-section {
  margin-bottom: 30px;
}

.totals-section h3,
.detailed-section h3,
.savings-section h3,
.hivepower-section h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: var(--text-primary, #14171a);
  font-weight: 700;
}

.hivepower-table th {
  text-transform: none;
}

.hive-raw-controls {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.raw-toggle {
  padding: 8px 12px;
  border-radius: 8px;
  border: none;
  background: var(--accent-primary, #1da1f2);
  color: white;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
}

.raw-data-block {
  background: var(--bg-primary, #f7f9f9);
  border: 1px solid var(--border-color, #e1e8ed);
  padding: 12px;
  border-radius: 8px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', 'Courier New', monospace;
  font-size: 12px;
  white-space: pre-wrap;
  overflow: auto;
  max-height: 240px;
}

.detailed-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.engine-raw-toggle {
  padding: 6px 10px;
  border-radius: 8px;
  border: none;
  background: var(--accent-secondary, #667eea);
  color: white;
  font-weight: 600;
  cursor: pointer;
}

.include-zero-label {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  color: var(--text-primary, #14171a);
}

.include-zero-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--accent-primary, #1da1f2);
}

/* Hide raw data buttons but keep functionality available in code */
.wallet-content .raw-toggle {
  display: none !important;
}

.table-container {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid var(--border-color, #e1e8ed);
}

.wallet-table,
.totals-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--bg-secondary, #fff);
}

.wallet-table thead,
.totals-table thead {
  background-color: var(--bg-primary, #f7f9f9);
  border-bottom: 2px solid var(--border-color, #e1e8ed);
}

.wallet-table th,
.totals-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 700;
  font-size: 13px;
  color: var(--text-secondary, #536471);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wallet-table td,
.totals-table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color, #e1e8ed);
  font-size: 15px;
  color: var(--text-primary, #14171a);
}

.wallet-table tbody tr:last-child td,
.totals-table tbody tr:last-child td {
  border-bottom: none;
}

.wallet-table tbody tr:hover,
.totals-table tbody tr:hover {
  background-color: var(--bg-primary, rgba(29, 161, 242, 0.05));
}

.ticker-cell {
  font-weight: 700;
  color: var(--accent-primary, #1da1f2);
}

.fetch-input {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ticker-input {
  padding: 8px 12px;
  border: 1px solid var(--border-color, #e1e8ed);
  border-radius: 8px;
  min-width: 220px;
  font-size: 14px;
}

.ticker-search-input {
  padding: 6px 10px;
  border: 1px solid var(--border-color, #e1e8ed);
  border-radius: 6px;
  font-size: 13px;
  background-color: var(--bg-secondary, #fff);
  color: var(--text-primary, #14171a);
  outline: none;
}
.ticker-search-input:focus {
  border-color: var(--accent-primary, #1da1f2);
}

.get-totals-button, .cancel-input {
  padding: 8px 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.get-totals-button {
  background: var(--accent-primary, #1da1f2);
  color: white;
}

.cancel-input {
  background: transparent;
  color: var(--text-secondary, #536471);
}

.input-error {
  color: #e0245e;
  font-size: 13px;
  margin-top: 6px;
}

.error-message {
  padding: 20px;
  text-align: center;
  color: #e0245e;
  font-size: 16px;
}

/* Dark theme support */
[data-theme="dark"] .wallet-content {
  background-color: var(--bg-secondary, #1e1e1e);
}

[data-theme="dark"] .wallet-header-fixed {
  background-color: var(--bg-secondary, #1e1e1e);
  border-bottom-color: var(--border-color, #38444d);
}

[data-theme="dark"] .wallet-header-fixed h2 {
  color: var(--text-primary, #e7e9ea);
}

[data-theme="dark"] .include-delegated-label {
  color: var(--text-primary, #e7e9ea);
}

[data-theme="dark"] .close-button {
  color: var(--text-secondary, #8b98a5);
}

[data-theme="dark"] .close-button:hover {
  background-color: rgba(29, 161, 242, 0.1);
  color: var(--text-primary, #e7e9ea);
}

[data-theme="dark"] .wallet-table,
[data-theme="dark"] .totals-table {
  background-color: var(--bg-secondary, #1e1e1e);
}

[data-theme="dark"] .wallet-table thead,
[data-theme="dark"] .totals-table thead {
  background-color: var(--bg-primary, #2c3640);
  border-bottom-color: var(--border-color, #38444d);
}

[data-theme="dark"] .wallet-table th,
[data-theme="dark"] .totals-table th {
  color: var(--text-secondary, #8b98a5);
}

[data-theme="dark"] .wallet-table td,
[data-theme="dark"] .totals-table td {
  border-bottom-color: var(--border-color, #38444d);
  color: var(--text-primary, #e7e9ea);
}

[data-theme="dark"] .wallet-table tbody tr:hover,
[data-theme="dark"] .totals-table tbody tr:hover {
  background-color: rgba(29, 161, 242, 0.05);
}

[data-theme="dark"] .table-container {
  border-color: var(--border-color, #38444d);
}

[data-theme="dark"] .ticker-search-input {
  background-color: var(--bg-primary, #2c3640);
  color: var(--text-primary, #e7e9ea);
  border-color: var(--border-color, #38444d);
}

[data-theme="dark"] .totals-section h3,
[data-theme="dark"] .detailed-section h3,
[data-theme="dark"] .savings-section h3 {
  color: var(--text-primary, #e7e9ea);
}

/* Responsive design */
@media (max-width: 768px) {
  .wallet-popup {
    padding: 10px;
  }

  .wallet-content {
    max-height: 95vh;
  }

  .wallet-header-fixed {
    padding: 15px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .wallet-header-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  }

  .header-controls {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .wallet-header-fixed h2 {
    font-size: 20px;
  }

  .close-button {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  .wallet-body {
    padding: 15px 20px;
  }

  .wallet-table th,
  .wallet-table td,
  .totals-table th,
  .totals-table td {
    padding: 8px 10px;
    font-size: 13px;
  }

  .wallet-table th,
  .totals-table th {
    font-size: 11px;
  }

  .fetch-totals-button {
    width: 100%;
  }
}

/* Scrollbar styling */
.wallet-body::-webkit-scrollbar {
  width: 8px;
}

.wallet-body::-webkit-scrollbar-track {
  background: var(--bg-primary, #f7f9f9);
}

.wallet-body::-webkit-scrollbar-thumb {
  background: var(--border-color, #ccd6dd);
  border-radius: 4px;
}

.wallet-body::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary, #536471);
}

[data-theme="dark"] .wallet-body::-webkit-scrollbar-track {
  background: var(--bg-primary, #2c3640);
}

[data-theme="dark"] .wallet-body::-webkit-scrollbar-thumb {
  background: var(--text-secondary, #536471);
}

[data-theme="dark"] .wallet-body::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary, #8b98a5);
}
`, "",{"version":3,"sources":["webpack://./src/components/WalletInfo/WalletInfo.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,2CAA2C;EAC3C,qDAAqD;EACrD,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qCAAqC;EACrC,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kEAAkE;EAClE,mCAAmC;AACrC;;AAEA;EACE,gDAAgD;EAChD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,aAAa;EACb,kBAAkB;EAClB,iGAAiG;EACjG,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4CAA4C;AAC9C;;AAEA,mEAAmE;AACnE;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;;EAEE,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,mCAAmC;AACrC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,mCAAmC;EACnC,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,4CAA4C;EAC5C,iDAAiD;AACnD;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".wallet-popup {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.wallet-content {\r\n  background-color: var(--bg-secondary, #fff);\r\n  border-radius: 12px;\r\n  max-width: 1200px;\r\n  width: 100%;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\r\n  position: relative;\r\n  color: var(--text-primary, #14171a);\r\n}\r\n\r\n.wallet-header-fixed {\r\n  position: sticky;\r\n  top: 0;\r\n  background-color: var(--bg-secondary, #fff);\r\n  border-bottom: 2px solid var(--border-color, #e1e8ed);\r\n  padding: 20px 30px;\r\n  border-radius: 12px 12px 0 0;\r\n  z-index: 10;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.wallet-header-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  flex: 1;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.header-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.include-delegated-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  color: var(--text-primary, #14171a);\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.include-delegated-checkbox {\r\n  width: 18px;\r\n  height: 18px;\r\n  cursor: pointer;\r\n  accent-color: var(--accent-primary, #1da1f2);\r\n}\r\n\r\n.wallet-header-fixed h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  color: var(--text-primary, #14171a);\r\n}\r\n\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  font-size: 32px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary, #536471);\r\n  padding: 0;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.close-button:hover {\r\n  background-color: var(--hover-background, rgba(29, 161, 242, 0.1));\r\n  color: var(--text-primary, #14171a);\r\n}\r\n\r\n.fetch-totals-button {\r\n  background-color: var(--accent-primary, #1da1f2);\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 20px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.fetch-totals-button:hover:not(:disabled) {\r\n  background-color: var(--accent-hover, #1a8cd8);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.fetch-totals-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.wallet-body {\r\n  overflow-y: auto;\r\n  padding: 20px 30px;\r\n  flex: 1;\r\n}\r\n\r\n.totals-section,\r\n.detailed-section,\r\n.savings-section,\r\n.hivepower-section {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.totals-section h3,\r\n.detailed-section h3,\r\n.savings-section h3,\r\n.hivepower-section h3 {\r\n  font-size: 20px;\r\n  margin-bottom: 15px;\r\n  color: var(--text-primary, #14171a);\r\n  font-weight: 700;\r\n}\r\n\r\n.hivepower-table th {\r\n  text-transform: none;\r\n}\r\n\r\n.hive-raw-controls {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.raw-toggle {\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background: var(--accent-primary, #1da1f2);\r\n  color: white;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  width: fit-content;\r\n}\r\n\r\n.raw-data-block {\r\n  background: var(--bg-primary, #f7f9f9);\r\n  border: 1px solid var(--border-color, #e1e8ed);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', 'Courier New', monospace;\r\n  font-size: 12px;\r\n  white-space: pre-wrap;\r\n  overflow: auto;\r\n  max-height: 240px;\r\n}\r\n\r\n.detailed-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.engine-raw-toggle {\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background: var(--accent-secondary, #667eea);\r\n  color: white;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.include-zero-label {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  font-size: 13px;\r\n  color: var(--text-primary, #14171a);\r\n}\r\n\r\n.include-zero-checkbox {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n  accent-color: var(--accent-primary, #1da1f2);\r\n}\r\n\r\n/* Hide raw data buttons but keep functionality available in code */\r\n.wallet-content .raw-toggle {\r\n  display: none !important;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border-color, #e1e8ed);\r\n}\r\n\r\n.wallet-table,\r\n.totals-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: var(--bg-secondary, #fff);\r\n}\r\n\r\n.wallet-table thead,\r\n.totals-table thead {\r\n  background-color: var(--bg-primary, #f7f9f9);\r\n  border-bottom: 2px solid var(--border-color, #e1e8ed);\r\n}\r\n\r\n.wallet-table th,\r\n.totals-table th {\r\n  padding: 12px 16px;\r\n  text-align: left;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  color: var(--text-secondary, #536471);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.wallet-table td,\r\n.totals-table td {\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid var(--border-color, #e1e8ed);\r\n  font-size: 15px;\r\n  color: var(--text-primary, #14171a);\r\n}\r\n\r\n.wallet-table tbody tr:last-child td,\r\n.totals-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.wallet-table tbody tr:hover,\r\n.totals-table tbody tr:hover {\r\n  background-color: var(--bg-primary, rgba(29, 161, 242, 0.05));\r\n}\r\n\r\n.ticker-cell {\r\n  font-weight: 700;\r\n  color: var(--accent-primary, #1da1f2);\r\n}\r\n\r\n.fetch-input {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.ticker-input {\r\n  padding: 8px 12px;\r\n  border: 1px solid var(--border-color, #e1e8ed);\r\n  border-radius: 8px;\r\n  min-width: 220px;\r\n  font-size: 14px;\r\n}\r\n\r\n.ticker-search-input {\r\n  padding: 6px 10px;\r\n  border: 1px solid var(--border-color, #e1e8ed);\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  background-color: var(--bg-secondary, #fff);\r\n  color: var(--text-primary, #14171a);\r\n  outline: none;\r\n}\r\n.ticker-search-input:focus {\r\n  border-color: var(--accent-primary, #1da1f2);\r\n}\r\n\r\n.get-totals-button, .cancel-input {\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n\r\n.get-totals-button {\r\n  background: var(--accent-primary, #1da1f2);\r\n  color: white;\r\n}\r\n\r\n.cancel-input {\r\n  background: transparent;\r\n  color: var(--text-secondary, #536471);\r\n}\r\n\r\n.input-error {\r\n  color: #e0245e;\r\n  font-size: 13px;\r\n  margin-top: 6px;\r\n}\r\n\r\n.error-message {\r\n  padding: 20px;\r\n  text-align: center;\r\n  color: #e0245e;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Dark theme support */\r\n[data-theme=\"dark\"] .wallet-content {\r\n  background-color: var(--bg-secondary, #1e1e1e);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-header-fixed {\r\n  background-color: var(--bg-secondary, #1e1e1e);\r\n  border-bottom-color: var(--border-color, #38444d);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-header-fixed h2 {\r\n  color: var(--text-primary, #e7e9ea);\r\n}\r\n\r\n[data-theme=\"dark\"] .include-delegated-label {\r\n  color: var(--text-primary, #e7e9ea);\r\n}\r\n\r\n[data-theme=\"dark\"] .close-button {\r\n  color: var(--text-secondary, #8b98a5);\r\n}\r\n\r\n[data-theme=\"dark\"] .close-button:hover {\r\n  background-color: rgba(29, 161, 242, 0.1);\r\n  color: var(--text-primary, #e7e9ea);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-table,\r\n[data-theme=\"dark\"] .totals-table {\r\n  background-color: var(--bg-secondary, #1e1e1e);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-table thead,\r\n[data-theme=\"dark\"] .totals-table thead {\r\n  background-color: var(--bg-primary, #2c3640);\r\n  border-bottom-color: var(--border-color, #38444d);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-table th,\r\n[data-theme=\"dark\"] .totals-table th {\r\n  color: var(--text-secondary, #8b98a5);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-table td,\r\n[data-theme=\"dark\"] .totals-table td {\r\n  border-bottom-color: var(--border-color, #38444d);\r\n  color: var(--text-primary, #e7e9ea);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-table tbody tr:hover,\r\n[data-theme=\"dark\"] .totals-table tbody tr:hover {\r\n  background-color: rgba(29, 161, 242, 0.05);\r\n}\r\n\r\n[data-theme=\"dark\"] .table-container {\r\n  border-color: var(--border-color, #38444d);\r\n}\r\n\r\n[data-theme=\"dark\"] .ticker-search-input {\r\n  background-color: var(--bg-primary, #2c3640);\r\n  color: var(--text-primary, #e7e9ea);\r\n  border-color: var(--border-color, #38444d);\r\n}\r\n\r\n[data-theme=\"dark\"] .totals-section h3,\r\n[data-theme=\"dark\"] .detailed-section h3,\r\n[data-theme=\"dark\"] .savings-section h3 {\r\n  color: var(--text-primary, #e7e9ea);\r\n}\r\n\r\n/* Responsive design */\r\n@media (max-width: 768px) {\r\n  .wallet-popup {\r\n    padding: 10px;\r\n  }\r\n\r\n  .wallet-content {\r\n    max-height: 95vh;\r\n  }\r\n\r\n  .wallet-header-fixed {\r\n    padding: 15px 20px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n  }\r\n\r\n  .wallet-header-title {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n    width: 100%;\r\n  }\r\n\r\n  .header-controls {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n  }\r\n\r\n  .wallet-header-fixed h2 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .close-button {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 15px;\r\n  }\r\n\r\n  .wallet-body {\r\n    padding: 15px 20px;\r\n  }\r\n\r\n  .wallet-table th,\r\n  .wallet-table td,\r\n  .totals-table th,\r\n  .totals-table td {\r\n    padding: 8px 10px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .wallet-table th,\r\n  .totals-table th {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .fetch-totals-button {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Scrollbar styling */\r\n.wallet-body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.wallet-body::-webkit-scrollbar-track {\r\n  background: var(--bg-primary, #f7f9f9);\r\n}\r\n\r\n.wallet-body::-webkit-scrollbar-thumb {\r\n  background: var(--border-color, #ccd6dd);\r\n  border-radius: 4px;\r\n}\r\n\r\n.wallet-body::-webkit-scrollbar-thumb:hover {\r\n  background: var(--text-secondary, #536471);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-body::-webkit-scrollbar-track {\r\n  background: var(--bg-primary, #2c3640);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-body::-webkit-scrollbar-thumb {\r\n  background: var(--text-secondary, #536471);\r\n}\r\n\r\n[data-theme=\"dark\"] .wallet-body::-webkit-scrollbar-thumb:hover {\r\n  background: var(--text-secondary, #8b98a5);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
